export default __webpack_public_path__ + "static/ministerstwo-6eb81be992dd661d746b604d83c037ad.png";